import { HttpStatusCode } from "axios";

// When adding to this enum, don't forget to add the corresponding status code in the object below
export enum ErrorEnum {
  ANALYTICS_FAIL = "ANALYTICS_FAIL",
  BROWSER_SESSION_INSERT_FAIL = "BROWSER_SESSION_INSERT_FAIL",
  CURRENT_SCENARIO_ID_NOT_EXIST = "CURRENT_SCENARIO_ID_NOT_EXIST",
  INTEGRATION_TYPE_NOT_MATCH = "INTEGRATION_TYPE_NOT_MATCH", // solution page
  INVALID_ANALYTIC_TYPE = "INVALID_ANALYTIC_TYPE",
  INVALID_INPUT = "INVALID_INPUT",
  INVALID_SHORTENED_URL = "INVALID_SHORTENED_URL",
  INVALID_SHORTCODE = "INVALID_SHORTCODE",
  INVALID_SCENARIO_ID = "INVALID_SCENARIO_ID",
  INVALID_SCENARIO_SESSION_ID = "INVALID_SCENARIO_SESSION_ID",
  INVALID_SOLUTION_ID = "INVALID_SOLUTION_ID",
  INVALID_SOLUTION_TYPE = "INVALID_SOLUTION_TYPE",
  MAINPAGE_NOT_EXIST = "MAINPAGE_NOT_EXIST",
  ROUTE_ONLY_SUPPORTS_GET_METHOD = "ROUTE_ONLY_SUPPORTS_GET_METHOD",
  ROUTE_ONLY_SUPPORTS_POST_METHOD = "ROUTE_ONLY_SUPPORTS_POST_METHOD",
  ROUTE_ONLY_SUPPORTS_GET_POST_METHODS = "ROUTE_ONLY_SUPPORTS_GET_POST_METHODS",
  SCENARIO_ID_NOT_DEFINED = "SCENARIO_ID_NOT_DEFINED",
  SCENARIO_ID_OR_SHORTCODE_NOT_PROVIDED = "SCENARIO_ID_OR_SHORTCODE_NOT_PROVIDED",
  SCENARIO_NOT_EXIST = "SCENARIO_NOT_EXIST",
  SCENARIO_SESSION_INSERT_FAIL = "SCENARIO_SESSION_INSERT_FAIL",
  SCENARIO_SESSION_UPDATE_FAIL = "SCENARIO_SESSION_UPDATE_FAIL",
  SCENARIO_VERSION_CHILD_NOT_EXIST = "SCENARIO_VERSION_CHILD_NOT_EXIST",
  SCENARIO_VERSION_CHILD_IS_NOT_A_SOLUTION = "SCENARIO_VERSION_CHILD_IS_NOT_A_SOLUTION",
  SCENARIO_VERSION_CHILD_SOLUTION_ACTION_TYPE_NOT_PROVIDED = "SCENARIO_VERSION_CHILD_SOLUTION_ACTION_TYPE_NOT_PROVIDED",
  SCENARIO_VERSION_CONTEXT_ELEMENT_NOT_EXIST = "SCENARIO_VERSION_CONTEXT_ELEMENT_NOT_EXIST",
  SCENARIO_VERSION_ID_NOT_EXIST = "SCENARIO_VERSION_ID_NOT_EXIST",
  SCENARIO_VERSION_ITEM_NOT_EXIST = "SCENARIO_VERSION_ITEM_NOT_EXIST",
  SCENARIO_VERSION_NOT_EXIST = "SCENARIO_VERSION_NOT_EXIST",
  SCENARIO_VERSION_NO_INITIAL_ITEM = "SCENARIO_VERSION_NO_INITIAL_ITEM",
  SOLUTION_ANALYTICS_FAIL = "SOLUTION_ANALYTICS_FAIL",
  SOLUTION_NOT_EXIST = "SOLUTION_NOT_EXIST",
  UNKNOWN_ERROR = "UNKNOWN_ERROR",
  WRONG_ID_SIGNATURE = "WRONG_ID_SIGNATURE",
  PUSH_TO_CONTRACK_FAIL = "PUSH_TO_CONTRACK_FAIL",
  GET_CONTEXT_FAIL = "GET_CONTEXT_FAIL",
  METHOD_NOT_ALLOWED = "METHOD_NOT_ALLOWED",
  CONTEXT_UPDATE_FAIL = "CONTEXT_UPDATE_FAIL",
}

export const mapBetweenErrorStatusAndMessages: { [key: string]: HttpStatusCode } = {
  [ErrorEnum.ANALYTICS_FAIL]: HttpStatusCode.Forbidden,
  [ErrorEnum.BROWSER_SESSION_INSERT_FAIL]: HttpStatusCode.Forbidden,
  [ErrorEnum.INTEGRATION_TYPE_NOT_MATCH]: HttpStatusCode.NotFound,
  [ErrorEnum.INVALID_ANALYTIC_TYPE]: HttpStatusCode.NotFound,
  [ErrorEnum.INVALID_INPUT]: HttpStatusCode.NotFound,
  [ErrorEnum.INVALID_SCENARIO_ID]: HttpStatusCode.NotFound,
  [ErrorEnum.INVALID_SCENARIO_SESSION_ID]: HttpStatusCode.NotFound,
  [ErrorEnum.INVALID_SHORTENED_URL]: HttpStatusCode.NotFound,
  [ErrorEnum.INVALID_SHORTCODE]: HttpStatusCode.NotFound,
  [ErrorEnum.INVALID_SOLUTION_ID]: HttpStatusCode.NotFound,
  [ErrorEnum.INVALID_SOLUTION_TYPE]: HttpStatusCode.Forbidden,
  [ErrorEnum.MAINPAGE_NOT_EXIST]: HttpStatusCode.Forbidden,
  [ErrorEnum.ROUTE_ONLY_SUPPORTS_GET_METHOD]: HttpStatusCode.MethodNotAllowed,
  [ErrorEnum.ROUTE_ONLY_SUPPORTS_POST_METHOD]: HttpStatusCode.MethodNotAllowed,
  [ErrorEnum.ROUTE_ONLY_SUPPORTS_GET_POST_METHODS]: HttpStatusCode.MethodNotAllowed,
  [ErrorEnum.SCENARIO_ID_NOT_DEFINED]: HttpStatusCode.NotFound,
  [ErrorEnum.SCENARIO_ID_OR_SHORTCODE_NOT_PROVIDED]: HttpStatusCode.NotFound,
  [ErrorEnum.SCENARIO_NOT_EXIST]: HttpStatusCode.NotFound,
  [ErrorEnum.SCENARIO_VERSION_CHILD_IS_NOT_A_SOLUTION]: HttpStatusCode.Forbidden,
  [ErrorEnum.SCENARIO_VERSION_CHILD_NOT_EXIST]: HttpStatusCode.Forbidden,
  [ErrorEnum.SCENARIO_VERSION_CHILD_SOLUTION_ACTION_TYPE_NOT_PROVIDED]: HttpStatusCode.NotFound,
  [ErrorEnum.SCENARIO_VERSION_CONTEXT_ELEMENT_NOT_EXIST]: HttpStatusCode.Forbidden,
  [ErrorEnum.SCENARIO_VERSION_ID_NOT_EXIST]: HttpStatusCode.Forbidden,
  [ErrorEnum.SCENARIO_VERSION_ITEM_NOT_EXIST]: HttpStatusCode.NotFound,
  [ErrorEnum.SCENARIO_VERSION_NO_INITIAL_ITEM]: HttpStatusCode.Forbidden,
  [ErrorEnum.SCENARIO_VERSION_NOT_EXIST]: HttpStatusCode.Forbidden,
  [ErrorEnum.SCENARIO_SESSION_INSERT_FAIL]: HttpStatusCode.Forbidden,
  [ErrorEnum.SCENARIO_SESSION_UPDATE_FAIL]: HttpStatusCode.Forbidden,
  [ErrorEnum.SOLUTION_ANALYTICS_FAIL]: HttpStatusCode.Forbidden,
  [ErrorEnum.SOLUTION_NOT_EXIST]: HttpStatusCode.Forbidden,
  [ErrorEnum.UNKNOWN_ERROR]: HttpStatusCode.BadRequest,
  [ErrorEnum.WRONG_ID_SIGNATURE]: HttpStatusCode.NotFound,
  [ErrorEnum.PUSH_TO_CONTRACK_FAIL]: HttpStatusCode.InternalServerError,
  [ErrorEnum.GET_CONTEXT_FAIL]: HttpStatusCode.NotFound,
  [ErrorEnum.METHOD_NOT_ALLOWED]: HttpStatusCode.MethodNotAllowed,
  [ErrorEnum.CONTEXT_UPDATE_FAIL]: HttpStatusCode.NotFound,
};

export const getErrorStatusCodeFromErrorMessage = (errorMessage: ErrorEnum): HttpStatusCode =>
  mapBetweenErrorStatusAndMessages[errorMessage as string] || HttpStatusCode.BadRequest;
